/* tslint:disable */
/* eslint-disable */
/**
 * PRMGApp
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 *
 * @export
 * @enum {string}
 */
export var TirePlacement;
(function (TirePlacement) {
    TirePlacement["Front"] = "Front";
    TirePlacement["Back"] = "Back";
})(TirePlacement || (TirePlacement = {}));
export function TirePlacementFromJSON(json) {
    return TirePlacementFromJSONTyped(json, false);
}
export function TirePlacementFromJSONTyped(json, ignoreDiscriminator) {
    return json;
}
export function TirePlacementToJSON(value) {
    return value;
}
